<template>
    <div>
        <div class="row mt-3 mb-3 align-items-center">
            <div class="col-auto">
                <div class="green-filter d-flex">
                    <div class="input-group">
                        <input type="date" class="form-control start-input-date" v-model="period_start" :disabled="loading">
                        <input type="date" class="form-control finish-input-date" v-model="period_end" :disabled="loading">
                        <div class="input-group-append" id="button-addon4">
                            <button
                                :class="'btn btn-outline-secondary-period-input active'"
                                type="button"
                                @click="getLeadAnalytic()"
                                :disabled="loading"
                            >Обновить</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <b-button @click="isMakeGraphPanel = !isMakeGraphPanel">
                    График
                    <b-icon icon="bar-chart-line" aria-hidden="true" v-if="!isMakeGraphPanel"></b-icon>
                    <b-icon icon="bar-chart-line-fill" aria-hidden="true" v-if="isMakeGraphPanel"></b-icon>
                </b-button>
            </div>
            <div class="col-auto">
                <b-form-select 
                    v-model="selectedGrouping" 
                    :options="optionsGrouping"
                    :disabled="loading"
                ></b-form-select>
            </div>
        </div>

        <GraphAnalytics
            v-if="isMakeGraphPanel"
            :buttons="fields.slice(1)"
            :items="formattedData"
            :whatTab="'leads'"
            class="mb-4"
        />

        <div class="mb-4">
            <b-table 
                :fields="fields"
                :items="formattedData" 
                bordered 
                striped 
                hover
                :busy.sync="loading"
                :sticky-header="computedWindowHeight"
                thead-tr-class="small-head all-th-black"
            >
                <template #cell(date)="data">
                    {{ data.item.date }}
                </template>
                <template #cell(group_1)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Лиды с другими причинами отказа')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(group_2)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Лиды с отказом: От нас. Физлицо')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(group_3)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Лиды с отказом: От нас. Нецелевой')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(group_4)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Лиды с отказом: От клиента. Слишком дорого')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(in_work)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Лиды в работе')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(other)="data">
                    <template v-if="data.value.length > 0">
                        <span class="cursor-pointer" @click="showByIds(data.value, 'orders', 'Лиды другие')">{{ data.value.length }}</span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </template>
                <template #cell(sum_of_group_2_group_3)="data">
                    <span class="cursor-pointer" @click="showByIds(getMergedArraysOf_2_3_Groups(data.item), 'orders', 'Отказные лиды по ключевым типам')">{{ getSumOf_2_3_Groups(data.item) }}</span>
                </template>
                <template #cell(sum_of_all)="data">
                    <span class="cursor-pointer" @click="showByIds(getMergedArraysOfAllGroups(data.item), 'orders', 'Все лиды')">{{ getSumOfAllGroups(data.item) }}</span>
                </template>
                <template #cell(frod)="data">
                    <b>{{ getValueOfFrod(data.item) }}%</b>
                </template>
            </b-table>
        </div>

        <tsoft-order-list
            v-if="orderList && orderList.length > 0"
            :openOrderList="openOrderList"
            :orderList="orderList"
            :label="orderListLabel"
            @closeOrderList="closeOrderList"
        >
        </tsoft-order-list>

        <p><em class="text-muted">* лид - заявка пришедшая с сайта</em></p>
    </div>
</template>

<script>
import OrderList from '@/components/orders/OrderList';
import GraphAnalytics from '@/components/orders/analytic/GraphAnalytics';
import { API_ORDERS_ANALYTICS_LEADS } from '@/constants';

export default {
    components: {
        "tsoft-order-list": OrderList,
        GraphAnalytics,
    },
    data() {
        return {
            loading: false,
            optionsGrouping: [
                { value: 'day', text: 'По дням' },
                { value: 'week', text: 'По неделям' },
                { value: 'month', text: 'По месяцам' },
            ],
            period_start: '',
            period_end: '',
            groups: {
            'group_1': [363, 365, 366, 367, 368, 953],
            'group_2': [584],
            'group_3': [952],
            'group_4': [364],
            },
            data: {},
            fields: [
                { key: 'date', label: 'Дата / Период' },
                { key: 'group_2', label: '', variant: 'warning' },
                { key: 'group_3', label: '', variant: 'warning' },
                { key: 'sum_of_group_2_group_3', label: 'Сумма ключевых отказов', variant: 'warning' },
                { key: 'group_4', label: '' },
                { key: 'group_1', label: 'Другие причины отказов' },
                { key: 'in_work', label: 'Не отказники' },
                // { key: 'other', label: 'Не попавшие в группы' }, // Для проверки не вылетает ли чего вне. Нужно открыть на бекенде тоже в OrderAnalytic.php!!!
                { key: 'sum_of_all', label: 'Сумма всех лидов', variant: 'primary' },
                { key: 'frod', label: 'Доля фрода', variant: 'danger' },
            ],
            orderList: [],
            openOrderList: false,
            orderListLabel: '',
            selectedGrouping: 'month',
            computedWindowHeight: '',
            isMakeGraphPanel: false,
        };
    },
    computed: {
        groupedData() {
            let grouped = {};
            for (const date in this.data) {
                let groupKey;
                if (this.selectedGrouping === 'week') {
                    groupKey = this.$moment(date).startOf('isoWeek').format('YYYY-MM-DD');
                } else if (this.selectedGrouping === 'month') {
                    groupKey = this.$moment(date).startOf('month').format('YYYY-MM-DD');
                } else {
                    groupKey = date; // daily grouping
                }

                if (!grouped[groupKey]) {
                    grouped[groupKey] = this.initializeGroupStructure();
                }

                for (const groupName in this.data[date]) {
                    const orders = this.data[date][groupName].order_ids;
                    grouped[groupKey][groupName].order_ids.push(...orders);
                }
            }
            return grouped;
        },
        formattedData() {
            this.$moment.locale('ru');
            const formatted = [];
            for (const date in this.groupedData) {
                const item = { date: this.formatDate(date, this.selectedGrouping), };
                const groups = this.groupedData[date];
                for (const groupName in groups) {
                    item[groupName] = groups[groupName].order_ids;
                }
                formatted.push(item);
            }
            return formatted;
        },
    },
    mounted() {
        this.handlerHeightWindow();
        this.getLeadAnalytic();
    },
    created() {
        window.addEventListener('resize', this.handlerHeightWindow);
    },
    destroyed() {
        window.removeEventListener('resize', this.handlerHeightWindow);
    },
    methods: {
        getLeadAnalytic() {
            this.loading = true;
            const request = {
                period_start: this.period_start,
                period_end: this.period_end,
                groups: this.groups,
            };
            axios
                .post(`${API_ORDERS_ANALYTICS_LEADS}`, request)
                .then(({ data }) => {
                    this.data = data.data;
                    this.period_start = data.params.period_start;
                    this.period_end = data.params.period_end;

                    this.setFields();

                    this.loading = false;
                });
        },
        showByIds(ids, type = 'orders', label = 'Список', order_to_manager = null) {
            if (type == 'orders') {
                this.orderList = ids;
                this.orderListLabel = label;
                this.openOrderList = true;
            }
        },
        closeOrderList() {
            this.orderList = [];
            this.openOrderList = false;
        },
        initializeGroupStructure() {
            return {
                'group_1': { order_ids: [] },
                'group_2': { order_ids: [] },
                'group_3': { order_ids: [] },
                'group_4': { order_ids: [] },
                'in_work': { order_ids: [] },
                'other': { order_ids: [] },
            };
        },
        formatDate(date, grouping) {
            if (grouping === 'day') {
                return this.$moment(date).format('DD.MM.YYYY');
            } else if (grouping === 'week') {
                const weekStart = this.$moment(date).startOf('isoWeek');
                const weekEnd = this.$moment(date).endOf('isoWeek');
                return `${weekStart.format('DD.MM')} - ${weekEnd.format('DD.MM.YYYY')} (${weekStart.format('W')}-я неделя)`;
            } else if (grouping === 'month') {
                return this.$moment(date).format('MMMM YYYY');
            }
            return date;
        },
        handlerHeightWindow() {
            let deleteHeight = 230
            this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`
        },
        setFields() {
            this.fields.forEach((field) => {
                if (field.label == '') {
                    field.label = this.groups[field.key].map(ref_id => this.$store.getters.REFERENCE_PROPERTIES[ref_id].text).join(' / ');
                }
            });
        },
        getSumOf_2_3_Groups(row) {
            let sum = 0;

            for (let key in row) {
                if (Array.isArray(row[key]) && 
                    ['group_2', 'group_3'].includes(key)) {
                    sum += row[key].length;
                }
            }

            return sum;
        },
        getMergedArraysOf_2_3_Groups(row) {
            let result = [];

            for (let key in row) {
                if (Array.isArray(row[key]) && 
                    ['group_2', 'group_3'].includes(key)) {
                    result = result.concat(row[key]);
                }
            }

            return result;
        },
        getSumOfAllGroups(row) {
            let sum = 0;

            for (let key in row) {
                if (Array.isArray(row[key])) {
                    sum += row[key].length;
                }
            }

            return sum;
        },
        getMergedArraysOfAllGroups(row) {
            let result = [];

            for (let key in row) {
                if (Array.isArray(row[key])) {
                    result = result.concat(row[key]);
                }
            }

            return result;
        },
        // sum_of_group_2_group_3 / sum_of_all * 100 = frod
        // getValueOfFrod(row) {
        //     let sumOfAll = this.getSumOfAllGroups(row);
        //     let sumOfGroup_2_Group_3 = this.getSumOf_2_3_Groups(row);

        //     if (sumOfAll === 0 || sumOfGroup_2_Group_3 === 0) { return 0; }

        //     return Math.round(sumOfGroup_2_Group_3 / sumOfAll * 100);
        // }
        getValueOfFrod(row) {
            let sumOfAll = this.getSumOfAllGroups(row);
            let group_2 = row['group_2'].length;

            if (sumOfAll === 0 || group_2 === 0) { return 0; }

            return Math.round(group_2 / sumOfAll * 100);
        },
    },
};
</script>

<style scoped>
.custom-select {
    height: 35px !important;
    line-height: 35px;
    padding: 0 30px 0 20px;
}
</style>